import React, { useState } from "react";
import { InputDropDown, TimerIcon } from "../common/Icon";
import Calendar from "react-calendar";
import TimeSelectorModal from "./TimeSelectorModal";

const MeetingCalenderModal = () => {
  const [dateState, setDateState] = useState(new Date());
  const changeDate = (e) => {
    setDateState(e);
  };
  const [timeSelectorModal, setTimeSelectorModal] = useState(false); // CREATE A FOLLOW UP PROFILE MODAL
  return (
    <>
      <div className="bg-white shadow-todays_workflow_box_shadow rounded-xl border border-solid border-[rgba(111,_106,_248,_0.10)]">
        <p className=" text-black text-xs font-semibold pb-3 pt-9 pl-5">
          Select Date and Time
        </p>
        <Calendar
          className={"!w-[320px] xs:!w-[375px] xm:!w-[430px] md:!w-[500px]"}
          value={dateState}
          onChange={changeDate}
        />

        <div className="w-[216px] flex items-center justify-between rounded border border-solid p-2 border-[rgba(111,_106,_248,_0.60)] bg-[rgba(111,_106,_248,_0.10)] mb-8 ms-5">
          <div className="flex items-center">
            <span className="pr-1">
              <TimerIcon />
            </span>
            <p className="text-[10px] text-black font-semibold opacity-70">
              Select Time
            </p>
          </div>
          <span
            onClick={() => setTimeSelectorModal(true)}
            className=" cursor-pointer">
            <InputDropDown />
          </span>
        </div>
        <div className=" fixed bottom-[29%] 2xl:bottom-[25%] md:right-[37%] lg:right-[28%] xl:right-[22%] 2xl:right-auto right-[28%] xs:right-[37%] 3xl:bottom-[18%] z-[99999]">
          {timeSelectorModal && <TimeSelectorModal />}
        </div>
        <div
          onClick={() => setTimeSelectorModal(false)}
          className={`fixed inset-0 min-h-full w-full z-[999]  bg-black opacity-10 ${
            timeSelectorModal ? "w-[100%] " : "hidden"
          }`}></div>
      </div>
    </>
  );
};

export default MeetingCalenderModal;
